import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SubscriptionState } from '../../../hooks/App/useSubscription';
import style from './index.module.css';
import { ExtendData } from '../../../hooks/App/useGetExposeExtendDataFromParent';

type LinkItem = {
  external: boolean,
  link: string,
  label: string
}

export const Menu: FC<{ 
  subscription: SubscriptionState,
  extendData: ExtendData | undefined
}> = ({
  subscription,
  extendData
}) => {

  // リンク先一覧
  const [linkList, setLinkList] = useState<LinkItem[]>([
    { external: true, link: '/pages/account', label: '購入履歴' },
    { external: true, link: '/pages/update-customer-info', label: 'お客様情報の更新' },
    { external: false, link: '/shippingAddress', label: 'お届け先情報の確認・変更' },
    { external: false, link: '/paymentMethod', label: 'お支払い方法の確認・変更' },
    { external: false, link: '/cancel', label: '解約する' },
    { external: true, link: '/pages/line-id', label: 'LINE連携' },
    { external: true, link: '/pages/omnihub', label: '会員バーコード表示' },
    { external: true, link: '/account/logout', label: 'ログアウト' },
  ]);

  useEffect(() => {
    if (!subscription) return;
    if (subscription.shop.showCancel === undefined) return;

    let next = linkList.concat();

    // 引数で受け取る「アプリ一般設定: 解約の表示」がfalseの場合は
    // 遷移するためのリンクを削除して再セットする
    if (subscription.shop.showCancel === false) {
      next = next.filter(item => item.link !== '/cancel');
    }

    setLinkList(next);
  }, [subscription, extendData]);
  
  return (
    <div className={style.menu}>
      <ul className={style.menuList}>
      {linkList.map(item => (
        <li className={style.menuItem}>
        {item.external ? (
          <a href={`https://kanro.jp${item.link}`} 
            target="_parent" className={style.menuLink}>
            {item.label}
          </a>
        ) : (
          <Link to={item.link} className={style.menuLink}>
            {item.label}
          </Link>
        )}
        </li>
      ))}
      </ul>
    </div>
  );

};
